<template>
  <b-alert
    show
    variant="danger"
  >{{ error }}</b-alert>
</template>

<script>
export default {
  props: {
    error: {
      type: Error
    }
  }
};
</script>
